// STATE
const state = { _pageTitle: {}, _subMenus: [] }

// ACTIONS
const actions = {
  addChildrenRoute({ commit }, param) {
    commit('setPageTitleMenu', param.pageTitle)
    commit('setSubMenus', param.subMenus)
  }
}
// MUTATIONS
const mutations = {
  setPageTitleMenu(state, paramPageTitle) {
    state['_pageTitle'] = {...paramPageTitle}
  },
  setSubMenus(state, paramSubMenus) {
    state['_subMenus'] = [...paramSubMenus]
  }
}
// GETTERS
const getters = {
  getPageTitleRoute() {
    return state['_pageTitle']
  },
  getSubMenusRoute() {
    return state['_subMenus']
  }
}
export const subMenus = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/_store/menu.module.js